<template>
  <div v-if="visible" class="app-install-banner">
    <img src="/images/logo-dark.svg" alt="" />
    <span class="app-install-banner__text">
      <strong>AudioScribe app</strong>
      <small>Record even with your screen locked</small>
    </span>
    <a
      class="app-install-banner__get"
      :href="storeUrl"
      target="_blank"
      rel="noopener"
      @click="onGet"
    >
      Get
    </a>
    <button
      type="button"
      class="app-install-banner__close"
      aria-label="Dismiss"
      @click="dismiss"
    >
      ✕
    </button>
  </div>
</template>

<script>
import { getMobilePlatform, getStoreUrl } from "@/utils/platform";
import { shouldShowBanner, snoozeBanner } from "@/utils/app-promo";
import { analytics } from "@/services/analytics.service";

export default {
  name: "AppInstallBanner",
  data() {
    const platform = getMobilePlatform();
    return {
      platform,
      // Plain state, decided once per mount: the snooze store isn't
      // reactive, so a computed here would only masquerade as one.
      visible: !!getStoreUrl(platform) && shouldShowBanner(),
    };
  },
  computed: {
    storeUrl() {
      return getStoreUrl(this.platform);
    },
  },
  mounted() {
    if (this.visible) {
      analytics.appBannerShown({ platform: this.platform });
    }
  },
  methods: {
    onGet() {
      analytics.appBannerClicked({ platform: this.platform });
    },
    dismiss() {
      snoozeBanner();
      this.visible = false;
      analytics.appBannerDismissed({ platform: this.platform });
    },
  },
};
</script>
